import api from "@/api/api";

const URL = "/source-materials";

export const getSourceMaterials = ({ page, limit, title, type } = {}) => {
  const params = {};

  if (title !== undefined) {
    params.title = title;
  }

  if (page !== undefined) {
    params.page = page;
  }

  if (limit !== undefined) {
    params.limit = limit;
  }

  if (type !== undefined) {
    params.type = type;
  }

  return api.get(URL, { params });
};

export const getSourceMaterial = (id) => {
  return api.get(`${URL}/${id}`);
};

export const createSourceMaterialFiles = (files) => {
  return api.post(`${URL}/files`, { files });
};

export const createSourceMaterials = (payload) => {
  return api.post(URL, payload);
};

export const updateSourceMaterials = (payload) => {
  const { id, ...rest } = payload;

  return api.patch(`${URL}/${id}`, rest);
};

export const deleteSourceMaterials = (id) => {
  return api.delete(`${URL}/${id}`);
};
